import { useEffect, useState } from "react";
import { API } from "@/lib/api";

const MONTHS = { en: ["January","February","March","April","May","June","July","August","September","October","November","December"],
                 es: ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"] };

const fmtDate = (d, lang) => {
  if (!d) return "";
  const [y, m] = d.split("-");
  const name = MONTHS[lang === "es" ? "es" : "en"][Number(m) - 1];
  return name ? `${name} ${y}` : y;
};

// Only rendered for a verified address. Image bytes stream through our backend; the key never reaches the browser.
export const StreetViewPhoto = ({ addressId, lang = "en" }) => {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    if (!addressId) return;
    setMeta(null);
    fetch(`${API}/address/streetview?address_id=${encodeURIComponent(addressId)}&meta=1`).then(r => r.json()).then(setMeta).catch(() => setMeta({ available: false }));
  }, [addressId]);
  if (!addressId || !meta) return null;
  if (!meta.available) {
    return <div className="mt-3 text-xs text-slate-500 border border-dashed border-slate-300 rounded-md p-3" data-testid="streetview-unavailable">
      {lang === "es" ? "No hay foto de calle disponible para esta dirección." : "No street photo available for this address."}</div>;
  }
  return (
    <figure className="mt-3" data-testid="streetview-figure">
      <img src={`${API}/address/streetview?address_id=${encodeURIComponent(addressId)}`} alt={lang === "es" ? "Foto a nivel de calle de la dirección verificada" : "Street-level photo of the verified address"}
           width={640} height={400} className="w-full rounded-md border border-slate-200 bg-slate-100" data-testid="streetview-image" />
      <figcaption className="mt-1 text-[11px] text-slate-500" data-testid="streetview-attribution">
        {lang === "es" ? "Imagen © Google" : "Image © Google"}{meta.date ? `, ${fmtDate(meta.date, lang)}` : ""}
      </figcaption>
    </figure>
  );
};
